import PropTypes from "prop-types";
import { Box, Typography } from "@material-ui/core";
import {
  ConfirmationNumber as TicketIcon,
  HourglassEmpty as PendingIcon,
  CheckCircle as ResolvedIcon,
  Warning as BreachedIcon,
} from "@material-ui/icons";

const STAT_CARDS = [
  {
    key: "total",
    label: "Total Tickets",
    icon: TicketIcon,
    bgColor: "rgba(90,149,89,0.1)",
    color: "#5A9559",
  },
  {
    key: "open",
    label: "Open Tickets",
    icon: PendingIcon,
    bgColor: "rgba(245,124,0,0.1)",
    color: "#F57C00",
  },
  {
    key: "avg_resolution",
    label: "Avg Resolution Time",
    icon: ResolvedIcon,
    bgColor: "rgba(56,142,60,0.1)",
    color: "#388E3C",
  },
  {
    key: "sla_compliance",
    label: "SLA Compliance",
    icon: BreachedIcon,
    bgColor: "rgba(156,39,176,0.1)",
    color: "#7B1FA2",
  },
];

const TicketStats = ({ data }) => {
  const getValue = (key) => {
    if (!data) return "\u2014";
    switch (key) {
      case "total":
        return data.total_tickets || 0;
      case "open":
        return data.open_tickets || 0;
      case "avg_resolution":
        return data.avg_resolution_time || "\u2014";
      case "sla_compliance":
        return data.sla_compliance_rate ? `${data.sla_compliance_rate}%` : "\u2014";
      default:
        return "\u2014";
    }
  };

  const getChange = (key) => {
    if (!data || !data.changes) return null;
    return data.changes[key] || null;
  };

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "repeat(4, 1fr)",
        gap: "16px",
        mb: 3,
      }}
    >
      {STAT_CARDS.map((card) => {
        const Icon = card.icon;
        const change = getChange(card.key);
        return (
          <Box
            key={card.key}
            sx={{
              backgroundColor: "#fff",
              borderRadius: "12px",
              padding: "20px",
              boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
              display: "flex",
              gap: "16px",
            }}
          >
            <Box
              sx={{
                width: 48,
                height: 48,
                borderRadius: "12px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: card.bgColor,
              }}
            >
              <Icon style={{ fontSize: 24, color: card.color }} />
            </Box>
            <Box>
              <Typography sx={{ fontSize: 13, color: "#6b778c", mb: 0.5 }}>
                {card.label}
              </Typography>
              <Typography sx={{ fontSize: 28, fontWeight: 600, color: "#172b4d" }}>
                {getValue(card.key)}
              </Typography>
              {change && (
                <Typography
                  sx={{
                    fontSize: 12,
                    mt: 0.5,
                    color: change.direction === "up" ? "#388E3C" : "#D32F2F",
                  }}
                >
                  {change.direction === "up" ? "\u2191" : "\u2193"} {change.value}
                </Typography>
              )}
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};

TicketStats.propTypes = {
  data: PropTypes.object,
};

export default TicketStats;
